<script setup lang="ts">

const props = defineProps<{
  title: string;
  availableOptions: { name: string; id: number }[];
  modelValue: any;
}>();

const emit = defineEmits(["update:modelValue"]);

const updateModelValue = (value: any) => {
  emit("update:modelValue", value);
};
</script>

<template>
  <fieldset :aria-label="props.title">
    <div class="flex items-center justify-between">
      <div class="text-sm font-medium leading-6 text-gray-600" v-if="props.availableOptions.length !== 0">
        {{ props.title }}
      </div>
    </div>

    <HeadlessRadioGroup :model-value="props.modelValue" @update:model-value="updateModelValue" class="mt-2">
      <HeadlessRadioGroupOption as="template" v-for="option in props.availableOptions" :key="option.name"
        :value="option" v-slot="{ active, checked }">
        <div :class="[
          active ? 'ring-2 ring-primary ring-offset-2' : '',
          checked
            ? 'bg-primary text-white ring-0 hover:bg-primary-hover'
            : 'bg-white text-gray-500 ring-1 ring-[#D4D4D8] hover:bg-gray-50',
          !active && !checked ? 'ring-inset' : '',
          active && checked ? 'ring-2' : '',
          'cursor-pointer flex items-center justify-center rounded-md px-5 py-2 text-sm float-left mr-3 mb-4',
        ]">
          {{ option.name }}
        </div>
      </HeadlessRadioGroupOption>
    </HeadlessRadioGroup>
  </fieldset>
</template>
